export default __webpack_public_path__ + "static/media/loader-1.ce1dbe91.gif";